import {
  type CreateUserRes,
  type DeleteUserReq,
  type DeleteUserRes,
  type GetAuthRes,
  type GetUserOrganizationsRes,
  type GetUsersByIdsRes,
  type SaveUserReq,
  type SaveUserRes,
  createUserReqSchema,
  deleteUserReqSchema,
  getUserOrganizationsReqSchema,
  getUsersByIdsReqSchema,
  saveUserReqSchema,
} from '../entity/api/routes/user';
import { uniqueStrArr } from '../shared/utils';
import { apiRequest } from './request';

export async function createUser(
  authToken: string,
  utmData?: {
    signupSource?: string | null;
    signupMedium?: string | null;
    signupCampaign?: string | null;
    signupTerm?: string | null;
    signupGclid?: string | null;
    signupFbclid?: string | null;
    signupLiFatId?: string | null;
  }
) {
  const req = createUserReqSchema.parse({
    params: null,
    query: null,
    body: {
      signupSource: utmData?.signupSource ?? null,
      signupMedium: utmData?.signupMedium ?? null,
      signupCampaign: utmData?.signupCampaign ?? null,
      signupTerm: utmData?.signupTerm ?? null,
      signupGclid: utmData?.signupGclid ?? null,
      signupFbclid: utmData?.signupFbclid ?? null,
      signupLiFatId: utmData?.signupLiFatId ?? null,
    },
  });
  return apiRequest<CreateUserRes>(`/user`, 'POST', false, req.body, undefined, authToken);
}

export async function getAuthUser() {
  return apiRequest<GetAuthRes>(`/user`, 'GET', false, undefined);
}

export async function getUserByIds(ids: string[]) {
  const uniqueIds = uniqueStrArr(ids);
  const req = getUsersByIdsReqSchema.parse({
    params: null,
    query: null,
    body: { userIds: uniqueIds },
  });
  return apiRequest<GetUsersByIdsRes>(`/user/get-by-ids`, 'POST', false, req.body);
}

export async function updateUser(data: SaveUserReq['body']) {
  const req = saveUserReqSchema.parse({
    params: null,
    query: null,
    body: data,
  });
  return apiRequest<SaveUserRes>('/user', 'PATCH', true, req.body);
}

export async function deleteUser(data: DeleteUserReq['body']) {
  const req = deleteUserReqSchema.parse({
    params: null,
    query: null,
    body: data,
  });
  return apiRequest<DeleteUserRes>('/user/remove', 'POST', true, req.body);
}

export async function getUserOrganizations() {
  const req = getUserOrganizationsReqSchema.parse({
    params: null,
    query: null,
    body: null,
  });
  return apiRequest<GetUserOrganizationsRes>('/user/organizations', 'GET', true, req.body);
}
